import { render } from "./SkeletonLoader.vue?vue&type=template&id=882614d4&scoped=true&ts=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoader.vue?vue&type=script&lang=ts"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=882614d4&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882614d4"]])

export default __exports__